<template>
  <v-card class="polyglot-queries-card">
    <v-expansion-panel popout>
      <v-expansion-panel-content
        v-for="(query, key) in queries"
        :key="key"
        class="polyglot-queries-panel-content"
      >
        <v-layout align-content-space-between slot="header">
          <v-flex>{{query.title}}</v-flex>
          <v-layout justify-end v-if="query.guide"><a :href="query.guide" target="_blank">Syntax guide</a></v-layout>
        </v-layout>
        <v-card>
          <v-card-text class="polyglot-queries-text" v-html="query.text">
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <i18n path="modal.polyglotQueries.text" class="mt-4">
      <template v-slot:providerUrl>
        <a target="_blank" href="https://sr-accelerator.com/#/">{{ $t('modal.polyglotQueries.providerName') }}</a>
      </template>
    </i18n>
  </v-card>
</template>

<script>
const polyglot = require('@iebh/polyglot').default

const engines = [
  {name: 'PubMed abbreviation', title: 'PubMed (abbreviated)', guide: 'https://pubmed.ncbi.nlm.nih.gov/help/#author-search'},
  {name: 'PubMed full', title: 'PubMed (expanded)', guide: 'https://pubmed.ncbi.nlm.nih.gov/help/#author-search'},
  {name: 'Ovid MEDLINE', title: 'Medline (via Ovid)', guide: 'https://ospguides.ovid.com/OSPguides/medline.htm'},
  {name: 'Cochrane Library', title: 'Cochrane Library', guide: 'https://epoc.cochrane.org/sites/epoc.cochrane.org/files/public/uploads/Resources-for-authors2017/database_syntax_guide.pdf'},
  {name: 'Embase (Elsevier)', title: 'Embase', guide: 'http://supportcontent.elsevier.com/Support Hub/Embase/Files & Attachements/4559-EMBASE QUG.pdf'},
  {name: 'Ovid MEDLINE 2', title: 'Embase (Ovid)', guide: 'https://ospguides.ovid.com/OSPguides/embase.htm'},
  {name: 'CINAHL (Ebsco)', title: 'CINAHL', guide: 'https://www.ebscohost.com/nursing/product-training/cinahl-databases-training'},
  {name: 'Web of Science', title: 'Web of Science', guide: 'https://images.webofknowledge.com/images/help/WOS/hs_search_operators.html'},
  {name: 'WoS Advanced', title: 'WoS Advanced', guide: 'https://images.webofknowledge.com/images/help/WOS/hs_search_operators.html'},
  {name: 'Scopus (basic search)', title: 'Scopus (basic search)', guide: 'http://schema.elsevier.com/dtds/document/bkapi/search/SCOPUSSearchTips.htm'},
  {name: 'Scopus (advanced search)', title: 'Scopus (advanced search)', guide: 'http://schema.elsevier.com/dtds/document/bkapi/search/SCOPUSSearchTips.htm'},
  {name: 'PsycInfo (Ovid)', title: 'PsycInfo', guide: 'https://www.apa.org/pubs/databases/psycinfo?tab=4'},
  {name: 'ProQuest Health and Medical', title: 'ProQuest', guide: 'https://proquest.libguides.com/ld.php?content_id=60229138'},
  {name: 'SPORTDiscus', title: 'SPORTDiscus', guide: 'https://connect.ebsco.com/s/article/EBSCOhost-Searching-Tips?language=en_US'}
]
export default {
  name: 'PolyglotQueries',
  props: ['query'],
  computed: {
    queries: function () {
      const r = []
      const translated = polyglot.translateAll(this.query)
      engines.forEach(engine => {
        let polyglotQuery = translated[engine.name]
        let translatedQuery = this.$sanitize(polyglotQuery)
        if (polyglotQuery) {
          r.push({
            title: engine.title,
            text: translatedQuery,
            guide: engine.guide
          })
        }
      })
      if (translated.lexicalTreeJSON) {
        r.push({
          title: 'Lexical Tree (JSON)',
          text: JSON.stringify(translated.lexicalTreeJSON, undefined, 2)
            .replace(/\n/g, '<br>')
        })
      }
      return r
    }
  }
}
</script>

<style lang="scss" scoped>
.polyglot-queries {
  &-card {
    overflow: scroll;
    margin: 10px 0;
    border-radius: 10px;
  }
  &-text {
    background-color: $blue-grey-50;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/PolyglotQueries.vue